
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab__content-data');

    buttons.forEach((button) => {
      button.addEventListener('click', function () {
        let tabId = this.getAttribute('data-tab');

        buttons.forEach((btn) => btn.classList.remove('active'));
        contents.forEach((content) => content.classList.remove('active'));

        this.classList.add('active');
        document.getElementById(tabId).classList.add('active');
      });
    });
  });
